import { autoinject, transient } from "aurelia-framework";
import { GetPendingVetOrdersResponse, OrderAbandonRequest } from "../../models/vetting/vetting.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject()
@transient()
export class VetOrderService {

    constructor(private requestClient: RequestClientService) {
    }

    public getPendingOrders(): Promise<GetPendingVetOrdersResponse> {
        return this.requestClient.get(`VetOrder/GetPendingOrders`, {});
    }

    //refactor to abondon order
    public abandonScreening(request: OrderAbandonRequest): Promise<void> {
        return this.requestClient.post(`VetOrder/AbandonScreening`, {}, request);
    }
}